<template>
	<div class="refuse">
		<el-dialog :title="title" width="30%" :visible.sync="dialogRefuseVisible" @close="resetForms('refuseFrom')">
			<div class="tipsBox">
				<tips-box></tips-box>
			</div>
			<div class="tips" v-if="state === 1">
				<p class="yx-color-text-primary">注意：拒绝发货后将不可撤销，请确认后再操作</p>
			</div>
			<div class="product_box mt-10">
				<product-box :row="row"></product-box>
			</div>
			<div class="user_info_box mt-10">
				<user-info-box :row="row"></user-info-box>
			</div>
			<div class="mt-20">
				<el-form :model="refuseFrom" ref="refuseFrom" :rules="refuseRuels">
					<el-form-item label="拒绝发货理由：" :label-width="formLabelWidth" prop="refuse" v-if="state === 1">
						<el-input v-model="refuseFrom['refuse']" type="textarea" autocomplete="off" placeholder="请填写拒绝发货理由"></el-input>
					</el-form-item>
					<el-form-item prop="receive" v-else>
						<el-input
							v-model="refuseFrom['receive']"
							type="textarea"
							autocomplete="off"
							placeholder="请填写拒绝带货理由"
							maxlength="80"
							show-word-limit
						></el-input>
					</el-form-item>
				</el-form>
				<p v-if="state === 2" class="yx-color-text-primary fz-14">拒绝带货后，请联系团长确认退样相关事宜</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRefuseVisible = false">取 消</el-button>
				<el-button type="primary" @click="refuseConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import tipsBox from '@/components/common/tipsBox';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import { OrderRefuse, refuseDeliver } from '@/api/cooperationProgress';
export default {
	components: {
		productBox,
		userInfoBox,
		tipsBox,
	},
	name: 'refuse',
	data() {
		return {
			dialogRefuseVisible: false,
			refuseFrom: {
				refuse: '',
				receive: '',
			},
			refuseRuels: {
				refuse: [{ required: true, message: '请填写拒绝发货理由', trigger: 'blur' }],
				receive: [{ required: true, message: '请填写拒绝带货理由', trigger: 'blur' }],
			},
			formLabelWidth: '150px',
			state: 0,
			title: '',
			row: {},
		};
	},
	methods: {
		initrefuseFun(row, state, tabName) {
			this.tabName = tabName;
			this.row = row;
			this.state = state;
			if (state === 1) {
				this.title = '拒绝发货';
			} else {
				this.title = '拒绝带货';
			}
			this.dialogRefuseVisible = true;
		},
		refuseConfirm() {
			if (this.state === 1) {
				this.$refs.refuseFrom.validate(async valid => {
					if (valid) {
						let params = {
							cooperate_id: this.row.cooperate_id,
							refuse_delivery_content: this.refuseFrom.refuse,
							sample_sn: this.row.sample_sn,
						};
						const { code } = await refuseDeliver(params);
						if (code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogRefuseVisible = false;
						}
					}
				});
			} else {
				this.$refs.refuseFrom.validate(async valid => {
					if (valid) {
						let params = {
							cooperate_id: this.row.cooperate_id,
							refuse_content: this.refuseFrom.receive,
						};
						const { code } = await OrderRefuse(params);
						if (code == 0) {
							this.$message.success('操作成功');
							this.$emit('refreshList');
							this.dialogRefuseVisible = false;
						}
					}
				});
			}
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	background: #fef3e7;
	border: 1px solid #fba543;
	padding: 11px 16px;
}
</style>
